import HTTP from "../../http";

const STORE_ENDPOINT = "/stores";
const STORE_BY_ID_ENDPOINT = "/id/";

export async function getStoreById(id) {
  return await HTTP.get(STORE_ENDPOINT + STORE_BY_ID_ENDPOINT + id);
}
